import SettingsProvider from "contexts/SettingsContext";
import TitleContextProvider from "contexts/TitleContext";
import "nprogress/nprogress.css";
import {StrictMode} from "react";
import ReactDOM from "react-dom";
import "react-image-lightbox/style.css";
import {BrowserRouter} from "react-router-dom";
import "simplebar/dist/simplebar.min.css";
import {Provider} from "react-redux"
import App from "./App";
import "./__fakeApi__";
import store from "./store";

ReactDOM.render(
    <StrictMode>
        <Provider store={store}>
                <SettingsProvider>
                    <TitleContextProvider>
                        <BrowserRouter>
                            <App/>
                        </BrowserRouter>
                    </TitleContextProvider>
                </SettingsProvider>
        </Provider>
    </StrictMode>,
    document.getElementById("root")
)
